
const translation = {
  nav_used_pallets: "Gebruikte Pallets",
  nav_new_pallets: "Nieuwe Pallets",
  nav_services: "Diensten",
  nav_about: "Over Ons",
  nav_faq: "FAQ",
  nav_contact: "Contact",
  nav_get_quote: "Offerte",

  hero_location: "Antwerpen, België",
  hero_title_line1: "PREMIUM",
  hero_title_line2: "EURO PALLETS",
  hero_subtitle: "Betrouwbare leverancier van klasse A, klasse B gebruikte pallets en nieuwe houten pallets. Kwaliteitsgecontroleerd. Snelle levering door heel België.",
  hero_cta_quote: "Offerte Aanvragen",
  hero_cta_products: "Producten Bekijken",

  stat_years: "Jaar Ervaring",
  stat_pallets: "Geleverde Pallets",
  stat_grades: "Productklassen",
  stat_quality: "Kwaliteitsgecontroleerd",

  gallery_label: "Kwaliteit Die Je Ziet",
  gallery_title: "Onze Palletcollectie",
  gallery_grade_a: "Klasse A Premium",
  gallery_grade_b: "Klasse B Voordelig",
  gallery_new: "Nieuwe Pallets",
  gallery_custom: "Speciale Bestellingen",

  how_label: "Eenvoudig Proces",
  how_title: "Hoe Het Werkt",
  how_subtitle: "Van browsen tot levering, wij maken het bestellen van pallets snel en eenvoudig.",
  how_step1_title: "Bladeren & Selecteren",
  how_step1_desc: "Verken ons assortiment klasse A, klasse B en nieuwe houten pallets. Bekijk gedetailleerde specificaties en foto's.",
  how_step2_title: "Offerte / Bestelling",
  how_step2_desc: "Dien een offerteaanvraag in of plaats direct een bestelling online. We bevestigen binnen 24 uur.",
  how_step3_title: "Snelle Levering",
  how_step3_desc: "Ontvang uw pallets snel door heel België en Europa. Alle bestellingen worden voor verzending kwaliteitsgecontroleerd.",

  used_label: "Kwaliteit Gebruikte Pallets",
  used_title: "Gebruikte Euro Pallets",
  used_subtitle: "Kies uit klasse A premium of klasse B voordelige pallets. Allemaal geïnspecteerd en klaar voor onmiddellijk gebruik.",

  new_label: "Gloednieuwe Pallets",
  new_title: "Nieuwe Houten Pallets",
  new_subtitle: "ISPM15-gecertificeerde, exportklare pallets vervaardigd volgens de hoogste normen. Aangepaste maten beschikbaar.",

  product_quick_specs: "Snelle Specificaties",
  product_dimensions: "Afmetingen",
  product_load: "Laadvermogen",
  product_wood: "Houtsoort",
  product_order_now: "Nu Bestellen",
  product_view_details: "Details Bekijken",
  product_view_angles: "Hoeken & Details",
  product_tech_specs: "Technische Specificaties",
  product_key_features: "Belangrijkste Kenmerken",
  product_request_quote: "Offerte Aanvragen voor Dit Product",
  product_call_us: "Bel Ons",

  calc_current_price: "Huidige Prijs",
  calc_volume_hint: "Volumeprijzen beschikbaar – bestel meer en bespaar meer!",
  calc_total_price: "Totaalprijs",
  calc_price_per: "Prijs per pallet",
  calc_quantity: "Hoeveelheid",
  calc_pallets: "pallets",
  calc_order_now: "Bestellen",
  calc_current_selection: "Huidige Selectie",
  calc_pieces: "stuks",
  calc_per_pallet: "per pallet",
  calc_calculate: "Uw Bestelling Berekenen",
  calc_payment_methods: "BESCHIKBARE BETAALMETHODEN",
  calc_volume_pricing: "Volumeprijzen",
  calc_bulk_discount: "Bulkkorting toegepast",
  calc_min_order: "Minimale bestelling: 10 pallets",
  calc_payment_methods_label: "Betaalmethoden:",
  calc_total: "Totaal:",
  calc_select_qty: "Hoeveelheid & Betaling Selecteren",
  calc_total_price_label: "Totaalprijs",

  services_label: "Wat Wij Doen",
  services_title: "Onze Diensten",
  services_subtitle: "Van sorteren tot levering, wij bieden complete palletoplossingen voor uw bedrijf.",
  service1_title: "Palletsortering & -classificatie",
  service1_desc: "Deskundige handmatige inspectie en classificatie van elke pallet.",
  service2_title: "Bulklevering",
  service2_desc: "Grote bestellingen welkom. Concurrerende prijzen voor bulkaankopen.",
  service3_title: "Speciale Bestellingen",
  service3_desc: "Niet-standaard maten nodig? Wij vervaardigen op maat gemaakte houten pallets.",
  service4_title: "Snelle Levering",
  service4_desc: "Betrouwbare levering door heel België en Europa.",

  quality_label: "Onze Normen",
  quality_title: "Kwaliteitsklassensysteem",
  quality_subtitle: "Elke pallet die wij leveren wordt zorgvuldig geïnspecteerd en geclassificeerd volgens strenge Europese normen.",
  grade_a_label: "Premium Klasse",
  grade_b_label: "Standaard Klasse",
  grade_new_label: "Gloednieuw",

  about_label: "Wie Wij Zijn",
  about_title: "Antwerpen's Betrouwbare Palletpartner",
  about_p1: "PEL Partner Company is een gespecialiseerde Euro palletleverancier gevestigd in Antwerpen, België. Wij voorzien bedrijven door heel België en Europa van hoogwaardige pallets.",
  about_p2: "Of u nu premium klasse A pallets nodig heeft, voordelige klasse B voor algemene logistiek, of gloednieuwe pallets voor export — wij hebben de juiste oplossing voor de juiste prijs.",
  about_location: "Antwerpen, België",
  about_quality: "Elke pallet geïnspecteerd",
  about_delivery: "Snel door heel België",
  about_support: "Ma–Vr 8:00–18:00",
  about_years: "Jaar in Bedrijf",
  about_supplied: "Geleverde Pallets",

  videos_label: "Zie Het in Actie",
  videos_title: "Onze Operaties",
  videos_subtitle: "Bekijk hoe wij pallets sorteren, inspecteren en voorbereiden.",
  tab_sorting: "Sorteerproces",
  tab_quality: "Kwaliteitscontrole",
  tab_delivery: "Levering",
  video_sorting_title: "Handmatig Sorteren & Inspecteren",
  video_sorting_desc: "Elke pallet wordt handmatig op kwaliteit gecontroleerd",
  video_strict: "Strenge Inspectie",
  video_strict_desc: "Elke pallet wordt handmatig geïnspecteerd op structurele integriteit en EPAL-conformiteit.",
  video_sorted: "Gesorteerd op Klasse",
  video_sorted_desc: "Pallets worden zorgvuldig gesorteerd in klasse A, B en Nieuw.",
  video_reliable: "Betrouwbare Levering",
  video_reliable_desc: "Wij leveren door heel Antwerpen en België met snelle doorlooptijden.",

  why_title: "Waarom PEL Partner Kiezen?",
  why1_title: "Gecertificeerde Kwaliteit",
  why1_desc: "EPAL-gecertificeerde pallets, elke partij geïnspecteerd volgens Europese normen.",
  why2_title: "Concurrerende Prijzen",
  why2_desc: "Beste prijzen in Antwerpen voor klasse A, B en nieuwe pallets.",
  why3_title: "Snelle Doorlooptijd",
  why3_desc: "Snelle orderverwerking en levering door heel België.",
  why4_title: "Betrouwbare Partner",
  why4_desc: "Langdurige relaties gebaseerd op vertrouwen, consistentie en kwaliteit.",

  delivery_label: "Wij Leveren Door Heel België",
  delivery_title: "Onze Servicegebieden",
  delivery_subtitle: "Snelle en betrouwbare palletlevering naar grote steden en regio's door heel België en Europa.",

  faq_label: "Veelgestelde Vragen",
  faq_title: "Veelgestelde Vragen",
  faq_subtitle: "Vind antwoorden op de meest gestelde vragen over onze pallets, diensten en bestelproces.",
  faq_q1: "Welke palletklassen biedt u aan?",
  faq_a1: "Wij bieden drie klassen: Klasse A (premium gebruikte pallets in uitstekende staat), Klasse B (voordelige gebruikte pallets met kleine slijtage) en Nieuwe Houten Pallets (gloednieuw, ISPM15-gecertificeerd voor export).",
  faq_q2: "Wat is de minimale bestelhoeveelheid?",
  faq_a2: "Wij verwerken bestellingen van alle groottes, van kleine hoeveelheden tot bulkbestellingen. Neem contact met ons op om uw specifieke vereisten te bespreken.",
  faq_q3: "Naar welke gebieden levert u?",
  faq_a3: "Wij leveren door heel België, inclusief Antwerpen, Brussel, Gent, Brugge en Luik. Wij bedienen ook klanten door heel Europa.",
  faq_q4: "Wat zijn uw levertijden?",
  faq_a4: "Klasse A en B gebruikte pallets zijn doorgaans op voorraad en beschikbaar voor onmiddellijke levering. Nieuwe houten pallets kunnen 1-2 weken vereisen.",
  faq_q5: "Zijn uw pallets EPAL-gecertificeerd?",
  faq_a5: "Ja, onze klasse A pallets zijn EPAL-gecertificeerd en gestempeld. Alle nieuwe houten pallets zijn ISPM15 warmtebehandeld en gestempeld.",
  faq_q6: "Biedt u aangepaste palletmaten aan?",
  faq_a6: "Ja, wij kunnen nieuwe houten pallets vervaardigen in aangepaste afmetingen. Standaard EUR/EPAL-maat is 1200 × 800 mm.",
  faq_q7: "Hoe waarborgt u de palletkwaliteit?",
  faq_a7: "Elke pallet wordt handmatig geïnspecteerd door ons getrainde personeel. Wij controleren structurele integriteit en EPAL-conformiteit.",
  faq_q8: "Welke betaalmethoden accepteert u?",
  faq_a8: "Wij accepteren bankoverschrijvingen, creditcards en kunnen betalingsvoorwaarden regelen voor gevestigde zakelijke klanten.",

  contact_label: "Neem Contact Op",
  contact_title: "Neem Contact Op",
  contact_info_title: "Contactinformatie",
  contact_phone_label: "Telefoon",
  contact_email_label: "E-mail",
  contact_location_label: "Locatie",
  contact_hours_label: "Openingstijden",
  contact_hours_val: "Maandag – Vrijdag: 8:00 – 18:00",
  contact_call_now: "Nu Bellen",
  contact_email_us: "E-mail Sturen",
  contact_quote_title: "Offerte Aanvragen",
  form_name: "Naam",
  form_phone: "Telefoon",
  form_email: "E-mail",
  form_product: "Product",
  form_product_placeholder: "Selecteer een product...",
  form_product_a: "Gebruikte Euro Pallets — Klasse A",
  form_product_b: "Gebruikte Euro Pallets — Klasse B",
  form_product_new: "Nieuwe Houten Pallets",
  form_product_mixed: "Gemengde Bestelling",
  form_message: "Bericht",
  form_message_placeholder: "Vertel ons over uw vereisten, benodigde hoeveelheid...",
  form_send: "Aanvraag Versturen",
  form_sending: "Verzenden...",
  form_success_title: "Bericht Verzonden!",
  form_success_desc: "We nemen zo snel mogelijk contact met u op.",
  form_send_another: "Nog Een Versturen",
  form_error: "Er is iets misgegaan. Probeer het opnieuw of neem direct contact met ons op.",

  order_title: "Uw Bestelling Plaatsen",
  order_subtitle: "Vul uw gegevens in en we bevestigen uw bestelling binnen 24 uur.",
  order_company: "Bedrijfsnaam",
  order_company_ph: "Uw bedrijfsnaam",
  order_contact: "Contactnaam",
  order_contact_ph: "Uw volledige naam",
  order_quantity: "Hoeveelheid",
  order_quantity_ph: "Aantal pallets",
  order_address: "Leveringsadres",
  order_address_ph: "Straat, Stad, Postcode",
  order_date: "Gewenste Leveringsdatum",
  order_notes: "Aanvullende Opmerkingen",
  order_notes_ph: "Speciale vereisten of vragen...",
  order_cancel: "Annuleren",
  order_review: "Bestelling Controleren",
  order_summary_title: "Besteloverzicht",
  order_summary_subtitle: "Controleer uw bestelgegevens voordat u indient.",
  order_company_info: "Bedrijfsinformatie",
  order_company_name_label: "Bedrijfsnaam",
  order_contact_label: "Contactpersoon",
  order_email_label: "E-mail",
  order_phone_label: "Telefoon",
  order_details: "Bestelgegevens",
  order_product_label: "Product",
  order_qty_label: "Hoeveelheid",
  order_qty_unit: "pallets",
  order_address_label: "Leveringsadres",
  order_date_label: "Gewenste Datum",
  order_notes_label: "Aanvullende Opmerkingen",
  order_next_steps: "Volgende Stappen:",
  order_next_steps_desc: "Na het indienen zal ons team uw bestelling beoordelen en binnen 24 uur contact met u opnemen.",
  order_edit: "Bestelling Bewerken",
  order_confirm: "Bevestigen & Indienen",
  order_submitting: "Uw Bestelling Indienen...",
  order_submitting_desc: "Even geduld alstublieft.",
  order_success_title: "Bestelling Succesvol Ingediend!",
  order_ref_label: "Referentienummer",
  order_success_desc: "Bedankt voor uw bestelling! We zullen uw aanvraag beoordelen en binnen 24 uur contact met u opnemen.",
  order_close: "Sluiten",
  order_error: "Er is iets misgegaan. Probeer het opnieuw.",

  footer_products: "Producten",
  footer_contact: "Contact",
  footer_copyright: "© 2025 PEL Partner Company. Alle rechten voorbehouden.",
  footer_tagline: "Antwerpen, België — Euro Palletleverancier",
  footer_desc: "Uw betrouwbare Euro palletleverancier in Antwerpen, België. Klasse A, B en nieuwe houten pallets — kwaliteit gegarandeerd.",

  compare_label: "Vergelijking",
  compare_title: "Vergelijk Onze Palletklassen",
  compare_subtitle: "Weet u niet welke klasse het beste bij u past? Vergelijk alle drie opties in één oogopslag.",
  compare_feature: "Kenmerk",
  compare_grade_a: "Klasse A",
  compare_grade_b: "Klasse B",
  compare_new: "Nieuwe Pallets",
  compare_condition: "Staat",
  compare_condition_a: "Uitstekend — minimale slijtage",
  compare_condition_b: "Goed — lichte cosmetische slijtage",
  compare_condition_new: "Gloednieuw — ongebruikt",
  compare_certification: "Certificering",
  compare_certification_a: "EPAL-gecertificeerd",
  compare_certification_b: "Kwaliteitsgecontroleerd",
  compare_certification_new: "ISPM15-gecertificeerd",
  compare_load: "Laadvermogen",
  compare_load_a: "Tot 1500 kg",
  compare_load_b: "Tot 1000 kg",
  compare_load_new: "Tot 2000 kg",
  compare_export: "Exportklaar",
  compare_export_a: "Alleen EU",
  compare_export_b: "Alleen EU",
  compare_export_new: "Wereldwijd",
  compare_custom: "Aangepaste Maten",
  compare_custom_a: "Nee",
  compare_custom_b: "Nee",
  compare_custom_new: "Ja",
  compare_availability: "Beschikbaarheid",
  compare_availability_a: "Op Voorraad",
  compare_availability_b: "Op Voorraad",
  compare_availability_new: "Op Bestelling",
  compare_best_for: "Ideaal Voor",
  compare_best_for_a: "Voedingswaren, gevoelige goederen",
  compare_best_for_b: "Algemene opslag",
  compare_best_for_new: "Export & internationale verzending",
  compare_starting_price: "Vanaf Prijs",
  compare_cta: "Nu Bestellen",
  compare_yes: "Ja",
  compare_no: "Nee",
};

export default translation;
